import { Pipe, PipeTransform } from '@angular/core';
import type { CardsThatLayoutOntoPaper } from '../../../models/menu/section/cards-that-layout-onto-paper';

@Pipe({
  name: 'iterableCardStackColumns',
  standalone: false
})
export class IterableCardStackColumnsPipe implements PipeTransform {
  transform(cardsThatLayoutOntoPaper: CardsThatLayoutOntoPaper, nCardsOnPage: number): any[] {
    return Array(cardsThatLayoutOntoPaper?.getNumberOfVisibleColumnsOnPage(nCardsOnPage) || 1);
  }
}
